import React from 'react';
import {
    Responsive,
    SimpleList,
    Datagrid,
    TextField,
    SimpleForm,
    TextInput,
    LongTextInput,
    SelectInput,
    required
} from 'admin-on-rest';
import List from '../admin/List';
import Create from '../admin/Create';
import Edit from '../admin/Edit';
import EditButton from '../buttons/EditButton';
import TooltipIcon from '../components/TooltipIcon';
import ReactTooltip from 'react-tooltip';
import {viewStyles} from '../shared/styles-view';
import Avatar from 'material-ui/Avatar';
import Icon from 'material-ui/svg-icons/maps/place';

export const fuseLocationTypeIcon = Icon;

const styles = {
    fieldSmall: {flex: '0 1 10%', display: 'inline-block', maxWidth: '8.5em', overflow: 'hidden'},
    fieldWide: {flex: '0 1 80%', display: 'block', minWidth: '80%', maxWidth: '100%', overflow: 'hidden'},
};

/*
 * View: List
 */

// Set title for List Location Types
const ListTitle = <span><Avatar icon={<Icon/>} style={viewStyles.avatar} className="avatar-title"/>Location Types</span>;

const ListDescription = () => {
    return (
        <span>
            <p>A <strong>Location Type</strong> describes what type of Location each of your stores is. Your stores
                may be in different types of locations, such as a brick & mortar, strip mall, tent, stand, warehouse,
                booth, etc.</p>
            <img src="img-diagram-Location-Type-List.png" alt="Diagram of Locations - Location Types"
                 style={viewStyles.diagram}/>
        </span>
    );
};

export const fuseLocationTypeList = (props) => (
    <List {...props} title={ListTitle} desc={<ListDescription/>}>
        <Responsive
            small={
                <SimpleList
                    primaryText={record => record.name}
                    secondaryText={record => record.description}
                />
            }
            medium={
                <Datagrid bodyOptions={{stripedRows: false, showRowHover: true}}>
                    <TextField source="name"/>
                    <TextField source="description"/>
                    <EditButton/>
                </Datagrid>
            }
        />
    </List>
);

export const fuseLocationTypeListViewOnly = (props) => (
    <List {...props} title={ListTitle} desc={<ListDescription/>}>
        <Responsive
            small={
                <SimpleList
                    primaryText={record => record.name}
                    secondaryText={record => record.description}
                />
            }
            medium={
                <Datagrid bodyOptions={{stripedRows: false, showRowHover: true}}>
                    <TextField source="name"/>
                    <TextField source="description"/>
                </Datagrid>
            }
        />
    </List>
);

/*
 * View: Create form
 */

// Set title for Create Location Type
const CreateTitle = <span><Avatar icon={<Icon/>} style={viewStyles.avatar} className="avatar-title"/>Create a Location Type</span>;

const CreateDescription = () => {
    return (
        <span>
            <p>A <strong>Location Type</strong> describes what type of Location each of your stores is. Your stores
                may be in different types of locations, such as a brick & mortar, strip mall, tent, stand, warehouse,
                booth, etc.</p>
             <p>Create a Location Type by adding a Name and an optional Description.</p>
        </span>
    );
};

// Set defaults for Create form
const defaultCreateValues = {
    warehouse: false
};

/*
 * Create Location Type form
 */
export const fuseLocationTypeCreate = (props) => (
    <Create {...props} title={CreateTitle} desc={<CreateDescription/>}>
        <SimpleForm defaultValue={defaultCreateValues} redirect="list">
            <TextInput source="name" label="Name of Location Type" validate={[required]}/>
            <LongTextInput source="description" label="Description"/>
            <span style={viewStyles.fieldHeader}>
                Is this Location Type for Warehouses?
                <TooltipIcon dataFor="ttWarehouse"/>
                <ReactTooltip id="ttWarehouse" type="light" effect="solid" multiline={true} border={true}
                              className="tooltip">
                    If <em>Yes</em>, this Location Type is for Warehouses that receive inventory after a season
                    has closed.
                    <br/>
                    If <em>No</em>, this Location Type is not a Warehouse.
                    <br/><br/>
                    When a Location transfers inventory to another Location, the inventory typically must be
                    manually received or audited. When a Location has a Location Type for Warehouses, transferred
                    inventory is automatically received.
                </ReactTooltip>
            </span>
            <SelectInput source="warehouse" label="Yes/No"
                         choices={[
                             {id: true, name: 'Yes'},
                             {id: false, name: 'No'},
                         ]}
                         style={styles.fieldWide}
            />
            <span style={viewStyles.fieldDescription}>
                Inventory Transfers sent from Warehouses to Locations will be automatically received.
            </span>
        </SimpleForm>
    </Create>
);

/*
 * View: Edit form
 */

// Set title for Edit Location Type
const EditTitle = ({record}) => {
    return <span><Avatar icon={<Icon/>} style={viewStyles.avatar}
                         className="avatar-title"/>Edit {record ? `${record.name}` : 'Location Type'}</span>;
};

const EditDescription = () => {
    return (
        <span>
            <p>Modify the fields below. Click <strong>Save</strong> to store this Location Type.</p>
        </span>
    );
};

/*
 * Edit Location Type form
 */
export const fuseLocationTypeEdit = (props) => (
    <Edit {...props} title={<EditTitle/>} desc={<EditDescription/>}>
        <SimpleForm redirect="list">
            <TextInput source="name" label="Name of Location Type" validate={[required]}/>
            <LongTextInput source="description" label="Description"/>
            <span style={viewStyles.fieldHeader}>
                Is this Location Type for Warehouses?
                <TooltipIcon dataFor="ttWarehouse"/>
                <ReactTooltip id="ttWarehouse" type="light" effect="solid" multiline={true} border={true}
                              className="tooltip">
                    If <em>Yes</em>, this Location Type is for Warehouses that receive inventory after a season
                    has closed.
                    <br/>
                    If <em>No</em>, this Location Type is not a Warehouse.
                    <br/><br/>
                    When a Location transfers inventory to another Location, the inventory typically must be
                    manually received or audited. When a Location has a Location Type for Warehouses, transferred
                    inventory is automatically received.
                </ReactTooltip>
            </span>
            <SelectInput source="warehouse" label="Yes/No"
                         choices={[
                             {id: true, name: 'Yes'},
                             {id: false, name: 'No'},
                         ]}
                         style={styles.fieldWide}
            />
            <span style={viewStyles.fieldDescription}>
                Inventory Transfers sent from Warehouses to Locations will be automatically received.
            </span>
        </SimpleForm>
    </Edit>
);



// WEBPACK FOOTER //
// ./src/Fuse/Location/type.js